import {
  CustomersIcon,
  FileIcon,
  GarageIcon,
  GearSixIcon,
  IntersectIcon,
  TagIcon,
  TrendUpIcon
} from "@/frontend/shared/assets/icons";

export const sections = [
  { itemName: "Company", description: "Company details", icon: GarageIcon },
  { itemName: "Products", description: "List of products, IPs", icon: TagIcon },
  { itemName: "Metrics", description: "Industry specific metrics", icon: TrendUpIcon },
  { itemName: "Team", description: "Employees and roles", icon: CustomersIcon },
  { itemName: "Competitors", description: "List of competitors", icon: IntersectIcon },
  { itemName: "Data Room", description: "Market, Finance, Financing", icon: FileIcon },
  { itemName: "Organize", description: "Owners and stage", icon: GearSixIcon }
];
